import {
  EstateSubscriptionStatus,
  EstateSubscriptionTransition,
} from "@1games-ru/region-shared/dist/enums/estate/estate";

export const getIsActiveSubscribe = (
  transition: EstateSubscriptionTransition,
  status: EstateSubscriptionStatus,
) => {
  return (
    transition === EstateSubscriptionTransition.Start ||
    (status === EstateSubscriptionStatus.Active && transition !== EstateSubscriptionTransition.End)
  );
};
